import type { Sidebar } from "common/providers/modal/useSidebar";
import { ResolvedPDPPage } from "resolvers/pages/pdpPageResolver";
import { VehicleService } from "services/vehicle/vehicle";
import { getCSSVariableValue } from "utils/getCSSVariableValue";

import { Extra, IncludedExtrasProps } from "../components/VehicleDetails/components/IncludedExtras";
import { ComingSoonAlertModal } from "./ComingSoon";
import ContactInfoForm from "./ContactInfoForm";
import DeliveryOrCollectionDetailedView from "./DeliveryOrCollection/DetailedView";
import DeliveryOrCollectionFormView from "./DeliveryOrCollection/FormView";
import FeaturesSpecsModal from "./FeaturesSpecs";
import FinanceOptionsExplained from "./FinanceOptionsExplained";
import IncludedExtrasModal from "./IncludedExtras";
import PackModal from "./PackModal";
import StoreDetails from "./StoreDetails";
import ValuationRange, { ValuationRangeModalProps } from "./ValuationRange";
import ValuePartExchangeForm from "./ValuePartExchangeForm";
import VehicleConditionForm from "./VehicleConditionForm";
import VehicleQuestionsForm from "./VehicleQuestionsForm";
import VehicleValued from "./VehicleValued";
import FooterCloseButton from "./common/FooterCloseButton";

export const valuePartExchangeModal: Sidebar = {
    title: "Value your part exchange",
    content: {
        component: ValuePartExchangeForm,
    },
};

export const vehicleDetailsModal: Sidebar = {
    title: "Vehicle details",
    previousSidebar: valuePartExchangeModal,
    content: {
        component: VehicleConditionForm,
    },
};

export const vehicleQuestionsModal: Sidebar = {
    title: "Vehicle details",
    previousSidebar: vehicleDetailsModal,
    content: {
        component: VehicleQuestionsForm,
    },
};

export const yourDetailsModal: Sidebar = {
    title: "Your details",
    previousSidebar: vehicleQuestionsModal,
    content: {
        component: ContactInfoForm,
    },
};

export const vehicleValuedModal = (): Sidebar => ({
    title: "Your valuation",
    content: {
        component: VehicleValued,
    },
});

export const featuresSpecsModal: Sidebar = {
    title: "Vehicle details",
    disableScroll: true,
    content: {
        component: FeaturesSpecsModal,
    },
};

export const financeOptionsExplainedModal = (section: string): Sidebar => ({
    title: "Finance options explained",
    content: {
        component: FinanceOptionsExplained,
        props: { section },
    },
});

export const deliveryOrCollectionFormModal: Sidebar = {
    title: "Delivery or collection",
    content: {
        component: DeliveryOrCollectionFormView,
        footerComponent: () => <FooterCloseButton type="sidebar">Close</FooterCloseButton>,
    },
};

export const deliveryOrCollectionDetailedModal: Sidebar = {
    title: "Delivery or collection",
    content: {
        component: DeliveryOrCollectionDetailedView,
        footerComponent: () => <FooterCloseButton type="sidebar">Close</FooterCloseButton>,
    },
};

export const storeDetailsModal = (title: string): Sidebar => ({
    title,
    content: {
        component: StoreDetails,
    },
});

export const includedExtrasModal = (params: IncludedExtrasProps): Sidebar => {
    return {
        title: "Included extras",
        content: {
            component: IncludedExtrasModal,
            props: params,
        },
    };
};

export const valuationRangeModal = (params: ValuationRangeModalProps): Sidebar => {
    return {
        title: params?.higherOfferSidePanel?.higherOfferModalTitle,
        content: {
            component: ValuationRange,
            props: params,
        },
        previousSidebar: params.previousSidebar,
        closingModalGoesToPrevious: params.closingModalGoesToPrevious,
    };
};

export const packModal = ({
    extra,
    title,
    iconClassName,
}: {
    title: string;
    extra: Extra;
    iconClassName: string;
}): any => ({
    title,
    titleIcon: {
        icon: "Floors",
        color: getCSSVariableValue("--mp-primary-orange"),
        className: iconClassName,
    },
    content: {
        component: PackModal,
        props: extra,
    },
});

export const comingSoonVehicleAlertModal = (
    vehicle: VehicleService.Vehicle,
    content: ResolvedPDPPage["widgetRowContent"]["alertSidePanel"]
): Sidebar => {
    return {
        title: content.createAlertTitle,
        content: {
            component: ComingSoonAlertModal,
            props: { vehicle, content },
        },
    };
};
